import { CreateFormGrid } from 'ui/ManagerFinance/components'
import FormInput from './FormInput'
import { formHeaders } from './constants'

const CreateForm = () => {
	const rows = Math.ceil(formHeaders.length / 2)
	return (
		<CreateFormGrid
			style={{
				gridAutoFlow: 'column',
				gridTemplateRows: `repeat(${rows}, auto)`,
				paddingTop: '2rem',
				paddingBottom: '2rem',
			}}
		>
			{formHeaders.map((input, index) => (
				<FormInput key={`${input.key}-${index}`} input={input} />
			))}
		</CreateFormGrid>
	)
}

export default CreateForm
